import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Create MSAL instance only once using a singleton pattern
let msalInstanceSingleton = null;

const getMsalInstance = () => {
  if (!msalInstanceSingleton) {
    msalInstanceSingleton = new PublicClientApplication(msalConfig);
  }
  return msalInstanceSingleton;
};

export { getMsalInstance };
export const msalInstance = getMsalInstance();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MsalProvider instance={msalInstance}>
    <App />
  </MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
